// extracted by mini-css-extract-plugin
module.exports = {"abstract":"ContentOverviewAbstract_abstract__2Wfk4","tag":"ContentOverviewAbstract_tag__2ogF4","buttonWrapper":"ContentOverviewAbstract_buttonWrapper__2Jn5Z"};